export default __webpack_public_path__ + "static/saturn-e581b87767e525bb749414e2a9df8dc6.webp";